module.exports = __webpack_public_path__ + "pc/img/record.d0289dc0.png";